import React, { useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { get } from 'lodash';

import Modal from '../Modal';
import {useModal} from '../../hooks';
import {
  CSRF_TOKEN,
  requestCallback
} from '../../lib/helpers';

const CampaignFormModal = ({
  klassName = 'MainHeader__right__a MainHeader__right__a--bright-blue',
  title,
  label,
  campaign
}) => {
  const [modal, modalSet] = useModal({ keyboardBindings: true })

  function toggleModal() {
    modalSet(!modal)
  }

  const [submitBtnText, setSubmitBtnText] = useState("Submit")
  const [isSubmitted, setIsSubmitted] = useState(false)

  const onSubmit = (e) => {
    e.preventDefault()
    setIsSubmitted(true)
    setSubmitBtnText('Processing...')

    const $els = e.target.elements
    const formData = new FormData();
    formData.append('name', get($els, 'name.value', '').trim())
    formData.append('start_at', get($els, 'start_at.value', ''))
    formData.append('end_at', get($els, 'end_at.value', ''))
    formData.append('enable', get($els, 'enable.checked', null))
    formData.append('authenticity_token', CSRF_TOKEN)

    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    const [method, endpoint] = campaign ?
      ['PUT', `/${gon.currentProvider}/api/community_campaigns/${campaign.id}`] :
      ['POST', `/${gon.currentProvider}/api/community_campaigns`]

    requestCallback(
      axios({
        method: method,
        url: endpoint,
        data: formData,
        headers: headers
      })
    )
  }

  const defaultDateValue = (field) => {
    if (!!get(campaign, field)) {
      return moment(get(campaign, field)).format('YYYY-MM-DDTHH:mm')
    }
  }

  return (
    <React.Fragment>
      <a
        title={title}
        className={klassName}
        onClick={toggleModal}
      >
        {label}
      </a>

      <Modal
        isActive={modal}
        onToggleModal={() => {
          modalSet(false)
        }}
        reset
      >
        <div className='CampaignFormModal'>
          <h3 className='Modal__h3'>{title}</h3>

          <form
            className='CampaignFormModal__form'
            onSubmit={onSubmit}
          >
            <div className='Modal__form'>
              <label className='Container__form__label'>
                Name
              </label>
              <input
                type='text'
                className='Input'
                name='name'
                defaultValue={get(campaign, 'name')}
                required
              />

              <label className='Container__form__label'>
                Start at
              </label>
              <input
                type="datetime-local"
                className='Input'
                name='start_at'
                defaultValue={defaultDateValue('startAt')}
                required
              />

              <label className='Container__form__label'>
                End at
              </label>
              <input
                type="datetime-local"
                className='Input'
                name='end_at'
                defaultValue={defaultDateValue('endAt')}
                required
              />

              <div className="CampaignFormModal__form__checkbox">
                <label className="CampaignFormModal__form__checkbox__label">
                  <input type="checkbox" name="enable" defaultChecked={get(campaign, 'enable')} />
                  <span className="CheckBox"></span>
                  <span>Enable</span>
                </label>
              </div>

              <div className='CampaignFormModal__form__buttons' disabled={isSubmitted}>
                <a
                  className='Button Button--gray-light'
                  onClick={() => {
                    modalSet(false)
                  }}
                >
                  Cancel
                </a>

                <button
                  className='Button Button--red'
                >
                  {submitBtnText}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default CampaignFormModal
